var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('recording-position-tracker',{staticClass:"event-capture",attrs:{"updateInterval":_vm.updateInterval},on:{"elapsed":_vm.sendProgress}})}
var staticRenderFns = []

export { render, staticRenderFns }